export const CkeditorConstants = {
  suggestionType: {
    FORMAT_INLINE: 'formatInline',
    INSERTION: 'insertion',
    DELETION: 'deletion',
  },
  command: {
    ACCEPT_SUGGESTION: 'acceptSuggestion',
    DISCARD_SUGGESTION: 'discardSuggestion',
    DISCARD_ALL_SUGGESTION: 'discardAllSuggestions',
    DISCARD_SELECTED_SUGGESTIONS: 'discardSelectedSuggestions',
    ACCEPT_ALL_SUGGESTIONS: 'acceptAllSuggestions',
    REORDER_REFERENCES: 'reorderreferences',
    RENUMBER_NUMBERED_CITATIONS: 'renumbernumberedcitations',
    REORDER_UNNUMBERED_REFERENCES: 'reorderunnumberedreferences',
    DELETE_WEB_EMAIL_LINK: 'deletewebemaillink',
    DELETE_KEYWORDS_LINK: 'keyworddefinitiondelete',
    INSERT_OTHER_DOCUMENT_LINK: 'insertotherdocumentlink',
    CLICK: 'click',
    SELECT_ALL: 'selectAll',
    REORDER_KEYWORDS: 'reorderKeywords',
    KEYWORD_DEFINITION: 'keyworddefinition',
    REORDER_CITATIONS: 'renumbercitations',
    KEYWORD_UNDO_REDO: 'keywordUndoRedo',
  },
  dropdownLabels: {
    LABEL_RENUMBER_NUMBERED_CITATIONS: 'Renumber numbered citations',
    LABEL_REORDER_UNNUMBERED_REFERENCES: 'Reorder unnumbered references',
    LABEL_REORDER_KEYWORDS: 'Reorder keywords',
  },
  // Sidebar view-mode values used by WKDcoratorsComponent's sidebarModeSubject/UI comparisons.
  sidebarMode: {
    WIDE_SIDEBAR: 'Wide sidebar',
    INLINE: 'Inline',
  },
  // Machine-friendly sidebar mode values accepted from a site's app.config.json entry.
  sidebarModeConfigValue: {
    WIDE_SIDEBAR: 'wideSidebar',
    INLINE: 'inline',
  },
  /**
   * Note: Values in trackchangesMarkup variables should be as per trackchanges documentation
   */
  trackchangesMarkup: {
    SUGGESTION: 'data-suggestion',
    SUGGESTION_END_AFTER: 'data-suggestion-end-after',
    SUGGESTION_END_BEFORE: 'data-suggestion-end-before',
    SUGGESTION_START_AFTER: 'data-suggestion-start-after',
    SUGGESTION_START_BEFORE: 'data-suggestion-start-before',
  },
  commentsMarkup: {
    ADD_COMMENT: 'addComment',
    UPDATE_COMMENT: 'updateComment',
    REMOVE_COMMENT: 'removeComment',
    REMOVE_COMMENT_THREAD: 'removeCommentThread',
  },
  operation: {
    UNDO: 'undo',
    REDO: 'redo',
  },
  helperAttributes: {
    DATA_CKE_TOOLTIP_TEXT: 'data-cke-tooltip-text',
    DATA_USERTOOLTIP: 'data-usertooltip',
    SUBTEMPLATE_NAME: 'data-subtemplate-name',
    NO_ONE: 'data-noone',
    SUBTEMPLATES_ALLOW: 'data-subtemplates-allow',
    SUBTEMPLATES_RULES: 'data-subtemplates-rules',
    CONTENTEDITABLE: 'contenteditable',
    DATA_TEMPLATE: 'data-template',
    DATA_COMMENT_ID: 'data-comment-id',
    CITATION_COUNT: 'data-citationcount',
    PARENT_CITATION: 'data-parentcitation',
    NUMBERED_CITATION: 'numberedcitation',
    RESOURCE: 'resource',
    TYPE_OF: 'typeof',
    DATA_CURRENTFOCUSED_ELEMENT: 'data-currentfocused-element',
    DATA_IGNORE: 'data-ignore',
    DATA_UNLOCK: 'data-unlock',
    DATA_HIDEROWS: 'data-hiderows',
    DATA_SHOWROWS: 'data-showrows',
    TRACK_CHANGES_EDITING: 'TrackChangesEditing',
    LINK_HREF: 'linkHref',
    DATA_COMMENT: 'data-comment',
    RENUMBER_CITATIONS: 'renumbercitations',
    REMOVE_INSERTEDCITATION_DISCARD: 'removeInsertedCitationsOnDiscard',
    REMOVE_INSERTEDKEYWORD_DISCARD: 'removeInsertedKeywordOnDiscard',
    DATA_THREAD_ID: 'data-thread-id',
    DATA_COMMENT_THREAD_ID: 'data-comment-thread-id',
    REMOVE_KEYWORD_FROM_TRACKCHANGES: 'removeKeywordFromTrackChanges',
    REMOVE_KEYWORD_FROM_SUBTEMPLATES: 'removeKeywordFromSubtemplate',
    DISCARD_CITATION: 'discardCitation',
    DATA_CITATION_ID: 'data-citation-id',
    DATA_FIND_RESULT: 'data-find-result',
  },
  event: {
    EXECUTE: 'execute',
    CITATIONS_DELETE_FROM_DOCUMENT: 'citationsDeleteFromDocument',
    CITATION_PANEL_REORDER: 'citationsPanelReOrder',
    COPY_KEYWORD_FROM_KEYBOARD: 'copyKeywordFromKeyboard',
    KEYDOWN: 'keydown',
    KEYUP: 'keyup',
    DELETE_FORWARD: 'deleteContentForward',
    DELETE_CONTENT_BACK: 'deleteContentBackward',
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    SHOW_MESSAGE: 'showMessage',
    BACKWARD: 'backward',
    FORWARD: 'forward',
    PASTE: 'paste',
    PASTE_NOT_ALLOWED: 'pasteNotAllowed',
    PASTE_EXTERNAL_CONFIRMATION_REQUIRED: 'pasteExternalConfirmationRequired',
    Cut: 'cut',
    Delete: 'delete',
  },
  pasteSourceMarker: {
    ATTRIBUTE: 'data-wk-paste-source',
    INTERNAL: 'wk-adw',
    MIME: 'application/x-wk-adw-source',
  },
  htmlElement: {
    FIG_CAPTION: 'figcaption',
    INLINE_SPAN: 'inlinespan',
    SECTION: 'section',
    ASIDE: 'aside',
    HTML_ASIDE: 'htmlAside',
    HEADER: 'header',
    DIV: 'div',
    SPAN: 'span',
    PARAGRAPH: 'paragraph',
    FIGURE: 'figure',
    FIGURETAG: 'figureTag',
    VIDEO: 'video',
    INLINE_AUDIO: 'inlineaudio',
    INLINE_IMAGE: 'inlineimage',
    IMAGE: 'img',
    AUDIO: 'audio',
    LIST_ITEM: 'li',
    LINK_SPAN: 'linkspan',
    HTML_SPAN: 'htmlSpan',
    KEYWORD_SPAN: 'keywordspan',
    FIGURE_CAPTIONTAG: 'figurecaptionTag',
    FIG_CAPTIONTAG: 'figcaptionTag',
    TABLE: 'table',
  },
  htmlTagNames: {
    LI: 'li',
    UL: 'ul',
    OL: 'ol',
    P: 'p',
  },
  HEADINGS: [
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
  ],
  HEADING_TAG_NAMES: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  htmlAttributes: {
    ID: 'id',
    CLASS: 'class',
    HTML_ATTRIBUTES: 'htmlAttributes',
    NUMBERED_CITATION_CLASS: 'numbered-citation',
    REL: 'rel',
    PROPERTY: 'property',
    LIST_STYLE: 'listStyle',
    LIST_TYPE: 'listType',
    ABOUT: 'about',
  },
  attributeLinkingTypes: [
    'pcicore:WebResource',
    'pcicore:BibliographicResource',
    'pcicore:MediaResource',
  ],
  attributeToRemove: ['listIndent', 'listItemId', 'listType', 'listStyle'],
  attributeLinkOtherDocument: 'pcicore:BibliographicResource',
  attributeWebLink: 'pcicore:WebResource',
  attributeMediaResource: 'pcicore:MediaResource',
  linksTo: 'pcicore:linksTo',
  STATIC_LABEL: 'static-labelnames',
  elementClass: {
    suggestion_marker: 'ck-suggestion-marker',
    COMMENT: 'ck-comment-marker',
    suggestion_deletion_marker: 'ck-suggestion-marker-deletion',
    suggestion_insertion_marker: 'ck-suggestion-marker-insertion',
    LIST_CLASS: 'ck-list-bogus-paragraph',
  },
  commentAttributes: {
    APPROVE: 'approve',
    DRAFT: 'draft',
    REJECT: 'reject',
    RESOLVE: 'resolve',
    STATUS: 'status',
    TIMESTAMP: 'timestamp',
    USERNAME: 'username',
    ATTRIBUTES: 'attributes',
  },
  commentLabels: {
    APPROVE: 'Approve',
    REJECT: 'Reject',
    RESOLVE: 'Resolve',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    POST: 'Post',
    POST_COMMENT: 'Post comment',
    CANCEL: 'Cancel',
    CANCEL_COMMENT: 'Cancel comment',
  },
  localStorageItem: {
    trackchangesandcommentsdata: 'trackchangesandcommentsdata',
    currentUser: 'currentUser',
    subtemplateObject: 'subtemplateObject',
    EXISTING_SUBTEMPLATES: 'existingSubtemplates',
    enableInsertBtn: 'enableInsertBtn',
    baseHrefForLinkPlugin: 'baseHrefForLinkPlugin',
    IS_LI_TAG_UP_FOR_SUB_TEMP_INSERTION: 'isLiTagUpForSubTempInsertion',
    SUB_TEMPLATE_INSERTED_GUID: 'subtemplateInsertedGuid',
    DATA_UNLOCK_SECTION: 'dataUnlockSection',
    SUBTEMPLATE_OBJECT: 'subtemplateObject',
    SUBTEMPLATE_LIST: 'subTemplateList',
    IS_ALL_COMMENT_DELETED: 'isAllCommentDeleted',
    BASE_HREF_PATH_URL: 'baseHrefPathUrl',
    BASE_HREF_ID: 'baseHrefId',
    CURRENT_SITE_DATA: 'currentSiteData',
    BASE_HREF_FOR_KEYWORD: 'baseHrefForKeyword',
    KEYWORD_ID_SELECT_FOR_CHEVRON: 'keywordIdSelectForChevron',
    KEYWORD_DATA: 'keywordData',
    REMOVE_MARKER_OF_LINK: 'removeMarkerLink',
    RHP_CITATION_REF_CLICK: 'rhpCitationRefClicked',
  },
  class: {
    ckButtonContainer_ckComment_ckAnnotation:
      'ck-button-container ck-comment ck-annotation',
    ck_button: 'ck-button-',
    ck_button_approve: 'ck-button-approve',
    ck_button_reject: 'ck-button-reject',
    ck_status: 'ck-status',
    REF: 'ref',
    section_content: 'section-content',
    CK_COMMENT_RESOLVE: 'ck-comment-marker ck-resolved-comment',
    WK_KEYWORD_REF: 'wk-keyword-ref',
    HIGHLIGHT_KEYWORD: 'highlight-keyword-onscroll',
    CK_MEDIA_AUDIO: 'ck-media-audio',
    CK_MEDIA_VIDEO: 'ck-media-video',
    CK_MEDIA_IMAGE: 'ck-media-image',
  },
  style: {
    block: 'block',
    none: 'none',
  },
  tooltip: {
    COMMENT: 'comment',
    INSERT_CROSS_REFERENCE: 'Insert cross-references',
  },
  unLockValues: {
    no_one: 'NO-ONE',
    all: 'ALL',
  },
  subTemplates: 'subTemplates',
  rightClickOptions: {
    INSERT_SUBTEMPLATE: 'Insert Subtemplate',
    GO_TO_LINK_NAME: 'Go To Link',
    GO_TO_LINK_KEY: 'goToLink',
    EDIT_LINK_NAME: 'Edit Link',
    EDIT_LINK_KEY: 'editLink',
    DELETE_LINK_NAME: 'Delete Link',
    DELETE_LINK_KEY: 'deleteLink',
    REMOVE_SUBTEMPLATE: 'Remove Subtemplate',
    DELETE_KEYWORD_KEY: 'deleteKeyword',
  },
  COMMANDS: {
    CMD_TRACK_CHANGES: 'trackChanges',
  },
  PLUGINS: {
    TRACK_CHANGES: 'TrackChanges',
    TRACKCHANGE_EDITING: 'TrackChangesEditing',
    KeywordDeleteFromDocument: 'keywordDeleteFromDocument',
  },
  treeWalkerValueType: {
    Element_Start: 'elementStart',
    Element_End: 'elementEnd',
  },
  MEDIA_AND_INLINE_ELEMENTS: [
    'INLINEIMAGE',
    'INLINEAUDIO',
    'FIGURETAG',
    'TABLE',
  ],
  DATA_COMMENT_ATTRIBUTES: [
    'data-comment-start-before',
    'data-comment-end-after',
    'data-comment-start-after',
    'data-comment-end-before',
  ],
  DCTERMS_TITLE: 'dcterms:title',
  INSERT_CROSS_REF_OPTIONS: [
    {
      id: 'apacitations',
      label: 'APA citations',
    },
    {
      id: 'creditlists',
      label: 'Credit lists',
    },
    {
      id: 'footnotes',
      label: 'Footnotes',
    },
    {
      id: 'keywords',
      label: 'Keywords & definitions',
    },
    {
      id: 'numreferences',
      label: 'Numbered references',
    },
    {
      id: 'unnumreferences',
      label: 'Unnumbered references',
    },
  ],
  BLOCK_ELEMENTS: [
    'aside',
    'section',
    'div',
    'header',
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
    'paragraph',
    'article',
    'htmlArticle',
    'figure',
  ],
  KEYWORD_ATTRIBUTE: {
    KEYWORD_TYPE_OF: 'skos:Concept',
    KEYWORD_MARKER: 'keytermmarker',
  },
  REMOVE: 'remove',
  INSERT: 'insert',
  MEDIA_AND_INLINE_TAGS: {
    INLINE_IMAGE: 'inlineimage',
    INLINE_AUDIO: 'inlineaudio',
    FIGURE_TAG: 'figureTag',
    MEDIA_CLASS: 'media-class',
  },
};
